import { Injectable } from '@angular/core'
import { BehaviorSubject, debounceTime, fromEvent, mergeWith } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class DashboardSidebarService {
    private _isMobile = new BehaviorSubject(false)
    private _isOpenSidebar = new BehaviorSubject(true)
    isOpenSidebar$ = this._isOpenSidebar.asObservable()
    isMobile$ = this._isMobile.asObservable()

    constructor() {
        this.initialEvents()
    }

    hideSidebar(): void {
        this._isOpenSidebar.next(false)
    }

    openSidebar(): void {
        this._isOpenSidebar.next(true)
    }

    toggleSidebar(): void {
        this._isOpenSidebar.next(!this._isOpenSidebar.getValue())
    }

    private initialEvents(): void {
        fromEvent(window, 'resize')
            .pipe(mergeWith(fromEvent(window, 'load')), debounceTime(50))
            .subscribe(() => {
                if (window.innerWidth > 992) {
                    this.openSidebar()
                    this._isMobile.next(false)
                } else {
                    this._isMobile.getValue() ? this.isOpenSidebar : this.hideSidebar()
                    this._isMobile.next(true)
                }
            })
    }

    get isOpenSidebar(): boolean {
        return this._isOpenSidebar.getValue()
    }

    get isHideSidebar(): boolean {
        return !this._isOpenSidebar.getValue()
    }
}
